import { css, SerializedStyles } from "@emotion/react";
import { colors } from "@ui/style/colors";

export const getScrollbarStyle = (thickness: number): SerializedStyles => css`
	::-webkit-scrollbar {
		width: ${thickness}px;
		height: ${thickness}px;
	}

	/* Track */
	::-webkit-scrollbar-track {
		background: ${colors.transparent};
	}

	/* Handle */
	::-webkit-scrollbar-thumb {
		background-color: ${colors.grey25};
		border-radius: ${thickness}px;

		:hover {
			background-color: ${colors.grey50};
		}
	}
`;
